<template>
  <div class="container">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'InfoBlockWrapper'
}
</script>

<style scoped lang="scss">
.container {
  background-color: #F3F5F7;
  box-shadow: 0px 0px 1px 0px rgba(9, 30, 66, 0.94);
  padding: 8px 14px 10px 8px;
  border-radius: 4px;
  max-width: 332px;
  font-size: 10px;
  line-height: 20px;

  a {
    text-decoration: underline;
    cursor: pointer;
    color: unset;

    &:hover {
      text-decoration: underline;
    }

  }
}
</style>
